import React, { useState, useEffect, useRef } from 'react';

function LocalMediaSetting( data ) {
    const [ localMedia, setLocalMedia ] = useState( null )
    const videoError = ( err ) => { console.error( 'Error accessing media devices:', err )}
    const constraints = {
        audio: true,
        video: {
            width: { ideal: 320 },
            height: { ideal: 240 }
        }
    }

    useEffect(()=>{
        const setUpMedia = async () => {
            try {
                if( !localMedia && data.getStream ){
                    const stream = await navigator.mediaDevices.getUserMedia( constraints )
                    if( localMedia ) removeLocalMedia( stream )
                    if( stream && !localMedia ) {
                        setLocalMedia( stream )
                        data.setLocalMedia( stream )
                    }
                }
            } catch ( error ) {
                videoError( error )
            }
        }
        setUpMedia()

        return() => {
            if( localMedia ) removeLocalMedia( localMedia )
        }

    }, [ localMedia, data.getStream ])



    function removeLocalMedia ( stream ){
        try{
            stream.getTracks().forEach( track => track.stop() )
            setLocalMedia( null )
          }catch( e ){
            console.log( e )
          }
    }
    return null
}
export default LocalMediaSetting;
